import createVueApp from '@/common/createApp'

Styxie.Initializers.ProfileBilling = {
  edit: async() => {
    const { default: Component } = await import('@/vue_widgets/profile/billing_edit/index.vue')
    createVueApp(Component)
  },
  geogrid_purchases: async(props) => {
    const { default: Component } = await import('@/vue_widgets/profile/geogrid_purchases/index.vue')
    createVueApp(Component, { props })
  },
  keyword_purchases: async(props) => {
    const { default: Component } = await import('@/vue_widgets/profile/keyword_purchases/index.vue')
    createVueApp(Component, { props })
  },
  subscriptions: async(props) => {
    const { default: Component } = await import('@/vue_widgets/profile/billing_subscriptions/index.vue')
    createVueApp(Component, { props })
  }
}
